import {Injectable} from '@angular/core';
import {BaseService} from '../../../../../core/abstracts/base-service.abstract';
import {Creatable, ReadableById} from '../../../../../core/interfaces/base-service.interfaces';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {VehicleResponse} from '../model/vehicle-response.model';
import {ItemImageDto} from '../model/item-image.model';
import {NewVehicleRequest} from '../model/new-vehicle-request.model';
import {MultipartRequest} from '../../../../../core/interfaces/multipart-request.interface';
import {VehicleAssignKeyRequest} from '../../../key-number/model/vehicle-assign-key-request.model';

@Injectable({providedIn: 'root'})
export class VehicleService extends BaseService implements ReadableById<VehicleResponse>, Creatable<MultipartRequest<NewVehicleRequest>, VehicleResponse> {
  protected override endpoint: string = 'items';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  public getById(id: number | string): Observable<VehicleResponse> {
    return this.get<VehicleResponse>(id)
  }

  public create(payload: MultipartRequest<NewVehicleRequest>): Observable<VehicleResponse> {
    return this.post<VehicleResponse>('', this.convertToMultipartFormData(payload));
  }

  public listImages(id: number | string): Observable<ItemImageDto[]> {
    return this.get<ItemImageDto[]>(`${id}/images`);
  }

  public uploadImages(id: number | string, payload: Required<FormData>): Observable<ItemImageDto[]> {
    return this.post<ItemImageDto[]>(`${id}/images`, payload);
  }

  public deleteImage(id: number | string, imageId: number | string): Observable<void> {
    return this.delete<void>(`${id}/images/${imageId}`);
  }

  private convertToMultipartFormData(payload: MultipartRequest<NewVehicleRequest>): FormData {
    const formData = new FormData();

    formData.append('item', new Blob([JSON.stringify(payload.body)], {type: 'application/json'}));
    payload.files?.forEach(file => formData.append('files', file, file.name));

    return formData;
  }

  public assignKey(itemId: number, payload: Required<VehicleAssignKeyRequest>): Observable<VehicleResponse> {
    return this.post<VehicleResponse>(`${itemId}/key-manual`, payload);
  }
}
